// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"488":"9e5c2773","777":"5328ba35"}[chunkId] + ".chunk.js";
};